// @flow
// import middlewares if any
const req = (require: any).context('.', true, /\.\/.+\/middleware\.js$/);
module.exports = req.keys().map((key) => req(key).default);
